import * as yup from "yup";

const createRegisterSchema = (t) =>
    yup.object().shape({
        firstName: yup.string().trim().required(t("validation.firstNameRequired")),

        lastName: yup.string().trim().required(t("validation.lastNameRequired")),

        email: yup
            .string()
            .trim()
            .lowercase()
            .email(t("validation.emailInvalid"))
            .required(t("validation.emailRequired")),

        dob: yup
            .string()
            .required(t("validation.dobRequired"))
            .transform((value) => {
                // Convert YYYY-MM-DD (native date input) → MM/DD/YYYY
                if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                    const [year, month, day] = value.split("-");
                    return `${month}/${day}/${year}`;
                }
                return value;
            })
            .matches(
                /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/,
                t("validation.dobFormat")
            ),

        // productType: yup.string().required(t("validation.productTypeRequired")),

        userType: yup.string().required(t("validation.userTypeRequired")),

        gender: yup.string().required(t("validation.genderRequired")),

        organizationName: yup.string().trim().required(t("validation.organizationNameRequired")),

        postalCode: yup.string().trim().required(t("validation.postalCodeRequired")),

        password: yup
            .string()
            .min(6, t("validation.passwordMin"))
            .required(t("validation.passwordRequired")),

        confirmPassword: yup
            .string()
            .oneOf([yup.ref("password"), null], t("validation.confirmPasswordMatch"))
            .required(t("validation.confirmPasswordRequired")),
    });

export default createRegisterSchema;